import { Component, OnInit } from "@angular/core";
import { CommonModule } from "@angular/common";
import { MatButtonToggleModule } from "@angular/material/button-toggle";
import { MatIconModule } from "@angular/material/icon";
import { NexuTheme, ThemeService } from "../../styles/themes";

@Component({
  selector: "nexu-theme-switch",
  standalone: true,
  imports: [CommonModule, MatButtonToggleModule, MatIconModule],
  template: `
    <mat-button-toggle-group [value]="currentTheme" (change)="onThemeChange($event.value)" aria-label="Theme Selector">
      <mat-button-toggle [value]="themes.DEFAULT"> <mat-icon>palette</mat-icon> Rebrand 2025 </mat-button-toggle>
      <mat-button-toggle [value]="themes.LEGACY"> <mat-icon>history</mat-icon> Legacy </mat-button-toggle>
      <mat-button-toggle [value]="themes.DARK"> <mat-icon>dark_mode</mat-icon> Dark </mat-button-toggle>
    </mat-button-toggle-group>
  `,
  styles: [
    `
      :host {
        display: block;
      }

      mat-button-toggle-group {
        margin: 16px 0;
      }
    `,
  ],
})
export class ThemeSwitchComponent implements OnInit {
  themes = NexuTheme;
  currentTheme: NexuTheme = NexuTheme.DEFAULT;

  constructor(private themeService: ThemeService) {}

  ngOnInit(): void {
    this.currentTheme = this.themeService.getCurrentTheme();
  }

  onThemeChange(theme: NexuTheme): void {
    this.themeService.setTheme(theme);
    this.currentTheme = theme;
  }
}
